<script>
export default {
  name: 'CustomDatatable',
  props: {
    drfprovider: {
      type: Function,
      required: false,
      default: () => null
    },
    provider: {
      type: Function,
      required: false,
      default: () => null
    },
    tableheaders: {
      type: [Array, Object],
      required: true
    },
    perpage: {
      type: Number,
      required: false,
      default: 10
    },
    pageoptions: {
      type: Array,
      required: false,
      default() {
              let pages = []
              let perpage = this.perpage
              for (let index = 1; index <= 3; index++) {
                  pages.push(Math.pow(perpage, index))
              }
              return pages
          }
    },
    sortby: {
      type: String,
      required: false,
      default: ''
    },
    sortdesc: {
      type: NaN,
      required: false,
      default: null
    },
    emptyText: {
      type: String,
      default: 'Sin registros para mostrar'
    },
    emptyFilteredText: {
      type: String,
      default: 'No se encontraron registros'
    },
    responsiveTable: {
      type: Boolean,
      default: true,
      required: false,
    },
    striped: {
      type: Boolean,
      default: false,
      required: false,
    },
    hover: {
      type: Boolean,
      default: false,
      required: false,
    },
    selectable: {
      type: Boolean,
      default: false,
      required: false,
    },
    headVariant: {
      type: String,
      default: null,
      required: false,
    },
    selectMode: {
      type: String,
      default: 'single',
      required: false,
    },
    stickyHeader: {
      type: Boolean,
      default: false,
      required: false
    },
    perPageOptions: {
      type: Boolean,
      default: false,
      required: false
    }
},
data() {
  return {
    isBusy: false,
    filter: null,
    totalRows: 1,
    currentPage: 1,
    lastFilter: '',
  }
},
methods: {
    onFiltered(filteredItems) {
        if (this.filter !== this.lastFilter){
            // Trying to resolve filter search issues when
            // changing pages with an active filter
            this.currentPage = 1
            this.lastFilter = this.filter
        }
    },
    baseProvider(ctx){
        let promise = this.drfprovider(ctx)
        if (promise){
            return promise.then((data) =>{
                this.totalRows = data.count
                return data.results
            })
        }else{
            return this.provider(ctx)
        }
    },
    refresh(){
      this.$refs.table.refresh()
    },
    onRowSelected(items) {
      this.$emit('rowSelected', items[0])
    },
    selectRow(index) {
      this.$refs.table.selectRow(index)
    }
  }
}
</script>
<template>
  <b-container fluid class="p-0">
    <slot name="extra-filters">

    </slot>
    <b-row class="mx-sm-1 mb-1 justify-content-center justify-content-sm-between mt-2">
      <b-col cols="6" lg="2" md="3" sm="3" v-if="perPageOptions">
        <div class="d-flex flex-row align-items-center">
          <label for="perPageSelect" class="mb-0 mr-1">{{ $t('datatable.show') }}</label>
          <b-form-select
            id="perPageSelect"
            v-model="perpage"
            size="sm"
            :options="pageoptions"
            style="min-width: 80px;"
          ></b-form-select>
          <label for="perPageSelect" class="mb-0 ml-1">{{ $t('datatable.rows') }}</label>
        </div>
      </b-col>

      <b-col cols="12" :sm="perPageOptions? '6' : '12'" class="mt-1 mt-sm-0">
        <div class="d-flex flex-row align-items-center">
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              debounce="600"
              type="search"
              :placeholder="$t('datatable.typetosearch')"
            ></b-form-input>
            <b-input-group-append>
              <b-button disabled @click="filter = ''" variant="light" class="text-gray px-2">
                <i class="fad fa-search"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </b-col>

      <!-- <div class="d-flex flex-row align-items-center">
        <label for="perPageSelect" class="mb-0 mr-1">Show</label>
        <b-form-select
          id="perPageSelect"
          v-model="perpage"
          size="sm"
          :options="pageoptions"
        ></b-form-select>
        <label for="perPageSelect" class="mb-0 ml-1">Rows</label>
      </div>

      <div class="d-flex flex-row align-items-center">
        <b-input-group size="sm">
          <b-form-input
            id="filterInput"
            v-model="filter"
            debounce="600"
            type="search"
            :placeholder="$t('datatable.typetosearch')"
          ></b-form-input>
          <b-input-group-append>
            <b-button disabled @click="filter = ''" variant="primary">
              <i class="fad fa-search"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div> -->
      <!-- <b-col sm="12" md="5" class="my-1" v-if="perPageOptions">
        <b-form-group
          :label="$t('datatable.recordsperpage')"
          label-cols-sm="3"
          label-cols-md="5"
          label-cols-lg="5"
          label-align-sm="right"
          label-size="sm"
          label-for="perPageSelect"
          content-cols-sm="3"
          class="mb-0"
        >
        <b-form-select
          id="perPageSelect"
          v-model="perpage"
          size="sm"
          :options="pageoptions"
        ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="12" :md="perPageOptions? '7' : '12'" :class="'my-1' ">
        <b-form-group
          :label="perPageOptions ? $t('datatable.filter') : ''"
          :label-cols-sm="perPageOptions? '3' : '12'"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              debounce="600"
              type="search"
              :placeholder="$t('datatable.typetosearch')"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">{{ $t('datatable.clear') }}</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col> -->
      <!-- <b-col class="my-1 mx-3">
        <b-form-group
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              debounce="600"
              type="search"
              :placeholder="$t('datatable.typetosearch')"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">{{ $t('datatable.clear') }}</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col> -->
    </b-row>
    <b-row>
      <b-col class="p-0">
        <b-table
          ref="table"
          class="m-0 mb-2"
          :striped="striped" 
          :hover="hover" 
          small
          :items="baseProvider"
          :fields="tableheaders"
          :per-page="perpage"
          :current-page="currentPage"
          :busy="isBusy"
          :filter="filter"
          :sort-by.sync="sortby"
          :sort-desc.sync="sortdesc"
          :responsive="responsiveTable"
          show-empty
          :empty-text="emptyText"
          :empty-filtered-text="emptyFilteredText"
          @filtered="onFiltered"
          :selectable="selectable"
          :select-mode="selectMode"
          :head-variant="headVariant"
          @row-selected="onRowSelected"
          sort-icon-left
          :sticky-header="stickyHeader"
        >
          <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
          <template v-slot:table-busy>
            <div class="text-center text-corp my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> {{ $t('datatable.loading') }}...</strong>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6" md="6" class="my-1">
        <span class="text-primary">{{ $t('datatable.showing') }} {{ !totalRows ? 0 : ((currentPage - 1) * perpage) + 1 }} - {{ !totalRows ? 0 : currentPage * perpage >= totalRows ? totalRows : currentPage * perpage }} {{ $t('datatable.of') }} {{ totalRows }} {{ $t('datatable.totalrows') }}</span>
      </b-col>
      <b-col offset-md="2" sm="6" md="4" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perpage"
          align="right"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>